import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const MTLNavList: MenuItem[] = [
  {
    id: 1,
    name: 'contactInfo',
    componentName: 'ContactInfo',
    complete: false
  },
  {
    id: 2,
    name: 'incomeExpense',
    componentName: 'IncomeExpense',
    complete: false,
    icon: faMoneyBillTrendUp,
    subItems: [
      {
        id: 21,
        name: 'roomStatistics',
        confirmNavigation: true,
        componentName: 'RoomStatistics',
        complete: false
      },
      {
        id: 22,
        name: 'revenue',
        confirmNavigation: true,
        componentName: 'MotelRevenue',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 221,
            name: 'operatingRevenue',
            complete: false
          },
          {
            id: 222,
            name: 'nonOperatingIncomeRevenues',
            complete: false
          }
        ]
      },
      {
        id: 23,
        name: 'expenses',
        confirmNavigation: true,
        componentName: 'ExpenseContainer',
        hasTabs: true,
        complete: false,
        subItems: [
          {
            id: 231,
            name: 'directProductCost',
            complete: false
          },
          {
            id: 232,
            name: 'undistributedExpenses',
            complete: false
          },
          {
            id:233,
            name: 'managementFees',
            complete: false
          },
          {
            id: 234,
            name: 'fixedCharges',
            complete: false
          },
          {
            id: 235,
            name: 'nonOperatingIncomeExpenses',
            complete: false
          },
        ]
      },
      {
        id: 24,
        name: 'reserveForReplacementAllowance',
        confirmNavigation: true,
        componentName: 'ReserveForReplacementAllowance',
        complete: false
      },
      {
        id: 25,
        name: 'capitalExpSummary',
        confirmNavigation: true,
        componentName: 'CapitalCostsSummary',
        complete: false
      }
    ],
  },
  {
    id: 3,
    name: 'apartment',
    complete: false,
    icon: faBuilding,
    subItems: [
      {
        id: 31,
        name: 'suiteBreakdownTable',
        componentName: 'SuiteBreakdown',
        complete: false
      }
    ]
  },
  {
    id: 4,
    name: 'commercial',
    complete: false,
    icon: faCartShopping,
    subItems: [
      {
        id: 41,
        name: 'leaseInformationTable',
        componentName: 'LeaseInfo',
        complete: false
      },
      {
        id: 42,
        name: 'vacantAskingRate',
        complete: false,
        componentName: 'VacantAskingRate',
      },
      {
        id: 43,
        name: 'parkingSummary',
        complete: false,
        componentName: 'ParkingPropertySummary',
      }
    ]
  },
  {
    id: 5,
    name: 'comments',
    componentName: 'Comment',
    complete: false
  },
  {
    id: 6,
    name: 'summaryReview',
    componentName: 'Summary',
    complete: false,
    icon: faFilePdf
  },
  {
    id: 7,
    name: 'submit',
    componentName: 'Submit',
    complete: false,
    icon: faFileInvoiceDollar
  }
]

export default MTLNavList